import React from 'react';
import { LeadDistributionBoard } from './components/LeadDistributionBoard';
export function App() {
  return <LeadDistributionBoard data-id="element-0" data-mp="35d3hotxj88ir" />;
}